import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import saveAs from 'file-saver';

import i18next from 'i18next'

class PrivateSignPopup extends Component {
	constructor(props) {
	    super(props);
	    this.state = {

	    }

	    this.close = this.close.bind(this);
	    this.downloadImage = this.downloadImage.bind(this);
	}

	componentDidMount() {

	}

	downloadImage (b64Data) {
		const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
			  byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

			const blob = new Blob(byteArrays, {type: contentType});
			return blob;
		}

		const contentType = 'image/png';
		const blob = b64toBlob(b64Data, contentType);
		saveAs(blob, this.props.data.fileName + ".png")
	}

	close () {
		this.props.closePrivateSignPopup()
	}

	render() {
		return (
			<div className='popup'>
				<div className="popup_inner_private_sign">
					<div className="col-12" style={{paddingTop: "15px"}}>
						<img src={"data:image/png;base64," + this.props.data.privateSignImage} style={{minWidth: "300px", maxWidth: "100%", maxHeight: "100%"}} alt="qr" />
                    </div>
                    <div className="col-12" style={{paddingLeft: "20px", paddingRight: "20px"}}>
                    	<button className="btn btn-default btn-block" style={{marginTop: "5px"}} onClick={this.downloadImage.bind(this, this.props.data.privateSignImage)}>{i18next.t("download")}</button>
                    </div>
                    <div className="col-12" style={{paddingLeft: "20px", paddingRight: "20px"}}>
                    	<button className="btn btn-default btn-block" style={{marginTop: "10px", marginBottom: "10px"}} onClick={this.close}>{i18next.t("closeLabel")}</button>
                    </div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateSignPopup);